import {useNavigate, useParams} from "react-router-dom";
import Header from "../Components/Header/Header";
import Footer from "../Components/Footer/Footer";
import {useEffect, useState} from "react";
import {getWebinar} from "../actions/ApiCalls";
import {IMAGE_URL} from "../path";

function Webinar() {
    const { slug } = useParams<{ slug?: string }>();

    const navigate = useNavigate();

    const linkStyle: React.CSSProperties = {
        color: 'black',
        fontSize: '10px',
        fontFamily: "'Vinimark-Diatype', sans-serif",
        fontWeight: 600,
        textTransform: 'uppercase',
        textDecoration: 'underline',
        cursor: 'pointer',
    };
    const [webinar, setWebinar] = useState<any>(null);
    const [recommendations, setRecommendations] = useState<any[]>([])

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
        if (slug) {
            getWebinar(slug)
                .then(response => {
                    setWebinar(response.data.data.webinar);
                    setRecommendations(response.data.data.recommendations);
                    window.document.title =   response.data.data.webinar.seo_meta_title;

                })
                .catch(error => {
                    console.error("Failed to fetch webinar:", error);
                });

        }
    }, [slug]);

    const isMobile = windowWidth <= 835;

    // Function to modify iframe HTML for mobile
const getModifiedIframeHTML = (html: string) => {
    if (!html || !isMobile) return html;

    // Replace width and height attributes to make it responsive
    const modifiedHTML = html
        .replace(/width="[^"]*"/g, `width="${windowWidth}"`)
        .replace(/height="[^"]*"/g, `height="${Math.round(windowWidth * 9 / 16)}"`);

    console.log('Modified HTML:', modifiedHTML);

    return modifiedHTML;
};
    const globalStyles = `
  a {
    color: black !important;
    text-decoration: underline;



  }
`;

    return <div style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        width: '100%',
        // overflow: 'hidden'
    }}>
    <style>{globalStyles}</style>
        <Header />
        <div style={{marginBottom: '100px'}}>
            <div style={{
                display: 'flex',
                flexDirection: windowWidth > 835 ? 'row' : 'column',
                gap: '20px',
                marginTop: isMobile ? '50px' : '140px',
                paddingRight: isMobile ? '24px' : '20px',
                paddingLeft: isMobile ? '-24px' : '0',
                paddingTop: isMobile ? '24px' : '0',
            }}>
                <div style={{flex: 1}}>

                </div>
                <div style={{flex: 1, textAlign: 'left', marginLeft: windowWidth > 575 ? '56px' : '26px'}}>
                    <p><a style={linkStyle} onClick={() => navigate('/webinars')}>BACK to webinars</a></p>
                </div>
            </div>

            {isMobile ? (
                // Mobile layout: YouTube iframe on top, full width
                <div style={{ marginTop: '50px' }}>
                    <div
                        style={{
                            width: '100vw',
                            aspectRatio: '16/9',
                            marginBottom: '20px',


                        }}
                        dangerouslySetInnerHTML={{ __html: getModifiedIframeHTML(webinar?.youtube) }}
                    />
                    <div style={{
                        textAlign: 'left',
                    }}>
                        <div style={{width: '90%', marginBottom: '20px', marginLeft: '24px'}}>
                            <p style={{ fontWeight: 600, marginTop: 0, textTransform: 'uppercase' }}>{webinar?.title}</p>
                            <p style={{ fontWeight: 600, fontSize: '10px', lineHeight: '13px'}}>
                                {webinar?.created_at ? new Date(webinar.created_at).toISOString().split("T")[0] : ""}
                            </p>
                            <p style={{ fontWeight: 300 }}>{webinar?.year_posted}</p>
                            <div dangerouslySetInnerHTML={{ __html: webinar?.content }} />
                        </div>
                    </div>
                </div>
            ) : (
                // Desktop layout: maintain existing side-by-side layout
                <div
                    style={{
                        marginTop: '100px',
                        display: 'flex',
                        flexDirection: 'row',
                        // gap: '20px',
                        paddingRight: '20px',
                        marginLeft: '56px'

                    }}
                >
                    <div style={{ flex: 1 }}>
                        <div style={{display: "flex", flexDirection: 'column', height: '100%', justifyContent: 'flex-start', alignItems: 'flex-end'}}>
                            <div style={{ display: 'flex', alignContent: 'flex-end'}}>
                                <div
                                    style={{ width: '100%', aspectRatio: '16/9', }}
                                    dangerouslySetInnerHTML={{ __html: webinar?.youtube }}
                                />
                            </div>
                        </div>
                    </div>

                    <div style={{ flex: 1, textAlign: 'left' , marginLeft: '16px'}}>
                        <div style={{width: '70%', marginBottom: '20px'}}>
                            <p style={{ fontWeight: 600, marginTop: 0, textTransform: 'uppercase' }}>{webinar?.title}</p>
                            <p style={{ fontWeight: 600, fontSize: '10px', lineHeight: '13px'}}>
                                {webinar?.created_at ? new Date(webinar.created_at).toISOString().split("T")[0] : ""}
                            </p>
                            <p style={{ fontWeight: 300 }}>{webinar?.year_posted}</p>
                            <div dangerouslySetInnerHTML={{ __html: webinar?.content }} />
                        </div>
                    </div>
                </div>
            )}

            {/* Recommendations Section */}
            {recommendations.length > 0 && (
                <div style={{
                    marginTop: '60px',
                    padding: isMobile ? '0 24px' : '20px'
                }}>
                    <p style={{
                        marginBottom: '20px',
                        fontWeight: 400,
                        textAlign: 'left',
                        fontFamily: "'Vinimark-Diatype', sans-serif",

                    }}>
                        More Webinars
                    </p>
                    <div style={{
                        display: 'flex',
                        overflowY: 'scroll',
                        gap: '20px',
                        margin: '0 auto'
                    }}>
                        {recommendations.map((recommendation, index) => (
                            <div
                                key={index}
                                style={{
                                    cursor: 'pointer',
                                    textAlign: 'center',
                                    flex: '1 1 135px',
                                    minWidth: '135px',
                                    width: '25vw'
                                }}
                                onClick={() => navigate(`/webinars/${recommendation.search_name}`)}
                            >
                                <img
                                    src={IMAGE_URL + recommendation.image}
                                    alt={recommendation.title}
                                    style={{
                                        width: '100%',
                                        minWidth: '135px',
                                        aspectRatio: '1/1',
                                        objectFit: 'cover',

                                    }}
                                />
                                <p style={{
                                    marginTop: '10px',
                                    fontWeight: 600,
                                    fontSize: '13px',
                                    fontFamily: "'Vinimark-Diatype', sans-serif",
                                    textTransform: 'uppercase',
                                    textAlign: "left"
                                }}>
                                    {recommendation.title}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>

        <Footer />
    </div>
}

export default Webinar;
